"use client";

import { reportClientError } from "@/lib/observability/client-errors";
import { useEffect } from "react";

export default function GlobalError({ error }: { error: Error }) {
  useEffect(() => {
    reportClientError(error);
  }, [error]);

  return (
    <html>
      <body className="m-0">
        <main className="mx-auto max-w-sm px-4 py-16 text-center text-foreground bg-secondary min-h-screen flex flex-col items-center justify-center">
          {/* heading-display-ok: global-error renders without the root layout; --font-display CSS var is unavailable here */}
          <h1 className="text-xl font-semibold text-primary">
            This page failed to load
          </h1>
          <p className="mt-2 text-muted-foreground">
            We’ve logged the error. Try again or head back home.
          </p>
          {/* eslint-disable-next-line @next/next/no-html-link-for-pages */}
          <a
            href="/"
            className="mt-6 inline-block rounded-lg bg-card px-4 py-2 text-sm font-medium text-primary border border-border hover:bg-muted"
          >
            Back to home
          </a>
        </main>
      </body>
    </html>
  );
}
